import React from "react";

export function StatCard({ label, value, icon: Icon, hint, tone = "primary", testId }) {
  const tones = {
    primary: "text-blue-700 bg-blue-50",
    emerald: "text-emerald-700 bg-emerald-50",
    amber: "text-amber-700 bg-amber-50",
    slate: "text-slate-700 bg-slate-100",
    crimson: "text-red-700 bg-red-50",
  };
  return (
    <div className="bg-white border border-slate-200 rounded-md p-5 shadow-sm hover:border-slate-300 transition-colors h-full" data-testid={testId}>
      <div className="flex items-start justify-between">
        <span className="text-[11px] font-mono tracking-wider uppercase text-slate-500">{label}</span>
        {Icon && <span className={`h-8 w-8 rounded-md grid place-items-center ${tones[tone]}`}><Icon className="h-4 w-4" /></span>}
      </div>
      <div className="mt-3 font-display text-3xl font-bold text-slate-900 tabular-nums">{value}</div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
    </div>
  );
}
